import { toast } from "sonner";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Field, fieldInputCls } from "@/components/Field";
import { ScanButton } from "@/components/BarcodeScanner";
import { useT } from "@/lib/i18n";
import { setTyreModel } from "@/components/TyreModelFields";

export const findSetByBarcode = (sets, code) =>
  sets.find((s) => Object.values(s.tyres || {}).some((ty) => ty.barcode && ty.barcode === code.trim()));

export const StintTyreFields = ({ n, form, setForm, sets, eventId }) => {
  const { t } = useT();
  const setKey = n === 1 ? "tyre_set_id" : "tyre_set2_id";
  const own = sets.filter((s) => s.event_id === eventId);
  const lapsValue = n === 1 ? form.laps : form.laps2;
  const pickSet = (id) => {
    const tm = setTyreModel(sets.find((s) => s.id === id));
    const [bk, mk] = n === 1 ? ["tyre_brand", "tyre_model"] : ["tyre_brand2", "tyre_model2"];
    setForm((f) => ({ ...f, [setKey]: id, ...(tm ? { [bk]: tm.brand, [mk]: tm.model } : {}) }));
  };
  const other = sets.filter((s) => s.event_id !== eventId);
  const onScan = (code) => {
    const found = findSetByBarcode(sets, code);
    if (!found) {
      toast.error(`${t("barcode_not_found")}: ${code}`);
      return;
    }
    pickSet(found.id);
    toast.success(`${t("tyre_set_found")}: ${found.name}`);
  };
  const item = (s) => (
    <SelectItem key={s.id} value={s.id} data-testid={`stint${n}-set-option-${s.id}`}>
      {s.name}{s.event_id !== eventId ? ` · ${s.event_name}` : ""} · {s.total_laps} {t("laps_short")}
    </SelectItem>
  );
  return (
    <div className="grid grid-cols-1 sm:grid-cols-[1fr_auto] gap-4 items-end">
      <Field label={t("tyre_set")}>
        <div className="flex gap-1.5">
          <Select value={form[setKey] || "none"} onValueChange={(v) => pickSet(v === "none" ? null : v)}>
            <SelectTrigger data-testid={`stint${n}-set-select`} className={fieldInputCls}><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="none">{t("none")}</SelectItem>
              {own.length > 0 && <SelectGroup><SelectLabel>{t("this_event")}</SelectLabel>{own.map(item)}</SelectGroup>}
              {other.length > 0 && <SelectGroup><SelectLabel>{t("other_events")}</SelectLabel>{other.map(item)}</SelectGroup>}
            </SelectContent>
          </Select>
          <ScanButton testid={`stint${n}-scan-btn`} onScan={onScan} />
        </div>
      </Field>
      {lapsValue != null && lapsValue !== "" && (
        <div data-testid={`stint${n}-laps-info`} className="h-10 flex items-center px-3 border border-[#282D3D] rounded-sm font-mono text-xs text-slate-400">
          +{lapsValue} {t("laps_short")}
        </div>
      )}
    </div>
  );
};
